<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import OpenCuentasWidget from '../widgets/OpenCuentasWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Cuentas, Consultorios } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let abiertas = $state(0);
  let ingresosMes = $state<number | null>(null);
  let adeudado = $state<number | null>(null);
  let error = $state<string | null>(null);

  function rangoMes() {
    const d = new Date();
    const desde = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
    const hasta = d.toISOString().slice(0, 10);
    return { desde, hasta };
  }

  async function cargar() {
    error = null;
    const { desde, hasta } = rangoMes();
    try {
      const [cuentas, rep, estado] = await Promise.all([
        Cuentas.list(),
        Consultorios.reporteIngresos(desde, hasta).catch(() => null),
        Consultorios.estadoCuenta(desde, hasta).catch(() => null),
      ]);
      abiertas = cuentas.filter(c => c.estado === 'ABIERTA' || !c.estado).length;
      ingresosMes = rep?.totalIngresos ?? null;
      adeudado = estado?.totalAdeudado ?? null;
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  function fmt(n: number | null) {
    if (n == null) return '—';
    return new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ', maximumFractionDigits: 0 }).format(n);
  }

  const actions = [
    { id: 'cuentas', label: 'Cuentas', icon: '🧾' },
    { id: 'contabilidad', label: 'Contabilidad', icon: '📊' },
    { id: 'tesoreria', label: 'Tesorería', icon: '🏦' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 120000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Finanzas" subtitle="Facturación, cobros y reportes" variant="finanzas">
  <DashHero emoji="📊" title="Finanzas" subtitle="Indicadores de facturación y cuentas por cobrar" variant="finanzas" />
  <QuickActions {actions} onAction={onNavigate} />

  {#if error}<p class="err">{error}</p>{/if}

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Cuentas abiertas</div><div class="dash-kpi-value">{abiertas}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Ingresos mes</div><div class="dash-kpi-value">{fmt(ingresosMes)}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Por cobrar</div><div class="dash-kpi-value">{fmt(adeudado)}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Periodo</div><div class="dash-kpi-value">{new Date().toLocaleDateString('es-GT', { month: 'short', year: 'numeric' })}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><OpenCuentasWidget limit={12} /></div>
  </div>
</DashboardLayout>

<style>
  .err { color: var(--danger); font-size: 0.88rem; }
</style>
